import React from "react"
import { useTranslation } from "react-i18next"
import Typography from "@/components/Typography"
import Block from "@/components/Block"
import Box from "@/components/Box"
import { Container } from "./components/Container"
import Flex from "@/components/Flex"

export const BeyondShopSection = ({
  SendReceiveImage = `${process.env.ASSETS_BASE_URL}/pay/customer-page/send-receive-ui.webp`,
  description,
}: {
  SendReceiveImage: string
  description: string
}) => {
  const { t } = useTranslation("payCustomer")
  return (
    <Block backgroundColor={"#FFF"}>
      <Container>
        <Typography
          color="#0B1426"
          textAlign={"center"}
          as="h2"
          variant="h2"
          mx={"auto"}
          mb={[4]}
        >
          {t("shopping.title")}
        </Typography>
        <Flex
          flexDirection={["column", "row", "row"]}
          customCss={{ gap: 2 }}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Box
            width={[335, 356, 532]}
            height={[340, null, 515]}
            borderRadius={20}
            padding={[4, "25px 32px", 4]}
            position={"relative"}
            customCss={{
              background: `url(${process.env.ASSETS_BASE_URL}/pay/customer-page/prepaid.webp) center no-repeat`,
              backgroundSize: "cover",
            }}
          >
            <Typography
              variant="p"
              color={"#EAEEF4"}
              fontSize={[20, 20, 31]}
              fontWeight={600}
              lineHeight={"140%"}
            >
              {t("shopping.top_up_description")}
            </Typography>
            <Box
              as="img"
              position={"absolute"}
              src={`${process.env.ASSETS_BASE_URL}/pay/customer-page/prepaid-ui.webp`}
              loading="lazy"
              width={"100%"}
              height={"100%"}
              left={0}
              top={0}
              alt={
                "Image: Individual holding a phone demonstrating Crypto.com Pay's 'Mobile Airtime' feature. Easily top up your prepaid phone and receive up to 5% cashback. Simple three-step process to fund your prepaid phone with the added benefit of up to 5% cashback."
              }
            />
          </Box>
          <Box
            width={[335, 356, 532]}
            height={[340, null, 515]}
            borderRadius={20}
            padding={[4, "25px 32px", 4]}
            position={"relative"}
            customCss={{
              background: `url(${process.env.ASSETS_BASE_URL}/pay/customer-page/send-receive.webp) center no-repeat`,
              backgroundSize: "cover",
            }}
          >
            <Typography
              variant="p"
              color={"#0B1426"}
              fontSize={[20, 20, 31]}
              fontWeight={600}
              lineHeight={"140%"}
            >
              {t(description)}
            </Typography>
            <Box
              as="img"
              position={"absolute"}
              src={SendReceiveImage}
              width={"100%"}
              height={"100%"}
              left={0}
              top={0}
              loading="lazy"
              alt={
                "Image: Individual holding a phone demonstrating Crypto.com Pay's 'Send' feature. Seamlessly send and receive crypto without any fees. Convenient and fee-free crypto transfers to friends and contacts."
              }
            />
          </Box>
        </Flex>
      </Container>
    </Block>
  )
}
